
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_15824_6370)"}},[_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#6039FC"}}),_c('path',{attrs:{"d":"M5.83 6.105l-1.839.502a.836.836 0 00-.614.806 9.36 9.36 0 009.36 9.36c.376 0 .707-.25.807-.614l.501-1.838a.834.834 0 00-.485-.99l-2.005-.837a.84.84 0 00-.97.243l-.844 1.028a7.035 7.035 0 01-3.355-3.356l1.032-.844a.84.84 0 00.242-.97L6.824 6.59a.836.836 0 00-.99-.485H5.83zM11.896 6.433l.534-1.422c.05-.135.144-.203.279-.203.135 0 .229.068.28.203l.532 1.422 1.448.533c.118.051.178.144.178.28 0 .135-.06.228-.178.279l-1.447.533-.534 1.447c-.05.119-.144.178-.279.178-.135 0-.229-.06-.28-.178l-.533-1.447-1.421-.533c-.136-.05-.204-.144-.204-.28 0-.135.068-.228.204-.279l1.421-.533z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_15824_6370"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    